import JodooSdk from './jodoo';
import { JSSDK_URL } from '../constant';
import { sdkLog } from '../decorator';
import { SdkType } from '../interface';
import { asyncLoadScript } from '@libs/shared';

/**
 * 简道云 JdySdk
 * 公共 API 复用 JodooSdk，能力支持由各自 App 返回。
 * 为了方便后续区分，所以单独维护
 */
export default class JdySdk extends JodooSdk {
    constructor() {
        super();
        this.sdkType = SdkType.Jdy;
    }

    @sdkLog()
    loadScript() {
        return asyncLoadScript(JSSDK_URL.App.Jdy);
    }
}
